import client from './client';

// List stores with optional filtering
export const getRates = async (data) => {
  const res = await client.post(`/rates/get`, data);
  return res.data;
};

export const postRates = async (data) => {
  const res = await client.post(`/rates/`, data);
  return res.data;
};

// Remove a store
export const removeStore = async (storeId) => {
  const res = await client.get('/stores/store-remove', {
    params: { store: storeId }
  });
  return res.data;
};

// Get stores for a specific group
export const getStoresByGroup = async (groupId) => {
  const res = await client.get(`/groups/${groupId}/stores`);
  return res.data;
};

// Create a new store (if needed in future)
export const createStore = async (storeData) => {
  const res = await client.post('/stores', storeData);
  return res.data;
};

// Update a store (if needed in future)
export const updateStore = async (storeId, storeData) => {
  const res = await client.put(`/stores/${storeId}`, storeData);
  return res.data;
};

// Delete a store (if needed in future)
export const deleteStoreRate = async (data) => {
  const res = await client.post(`/rates/delete/store`, data);
  return res.data;
};

// Delete employee rates
export const deleteEmployeeRates = async (employeeId) => {
  const res = await client.delete(`/rates/employee/${employeeId}`);
  return res.data;
};
